import React, { useRef, useState } from "react";
import { toast } from "react-hot-toast";

import logo from "../assets/img/logo.svg";

import { sendEmailRecoverPassword } from "../services";

const initialState = {
  email: "",
  url:
    process.env.REACT_APP_DOMAIN ||
    window.location.origin,
};

export function EmailForm({
  handleChangeToLogIn,
}) {
  const [data, setData] = useState(initialState);

  const submitButtonRef = useRef(null);
  const emailInputRef = useRef(null);

  const handleOnChange = ({ name, value }) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    submitButtonRef.current?.setAttribute(
      "disabled",
      ""
    );

    const sendEmail =
      sendEmailRecoverPassword(data);

    sendEmail
      .then(() => {
        setData(initialState);
        emailInputRef.current?.blur();
      })
      .finally(() => {
        submitButtonRef.current?.removeAttribute(
          "disabled"
        );
      });

    toast.promise(
      sendEmail,
      {
        loading: "Enviando...",
        success:
          "Hemos enviado un correo de recuperación",
        error:
          "No fue posible enviar el correo",
      },
      {
        duration: 5000,
      }
    );
  };

  return (
    <div className="ps-login-card">

      <div className="ps-login-logo">
        <img
          src={logo}
          alt="PS Proceso Seguro"
        />
      </div>

      <div className="ps-login-heading">
        <h1>Recuperar contraseña</h1>
        <p>
          Ingresa el correo asociado a tu cuenta.
        </p>
      </div>

      <form
        className="ps-login-form"
        onSubmit={handleOnSubmit}
      >

        <div className="ps-login-field">
          <label htmlFor="recovery-email">
            Correo electrónico
          </label>

          <div className="ps-login-input">
            <i className="far fa-envelope" />

            <input
              ref={emailInputRef}
              id="recovery-email"
              name="email"
              type="email"
              required
              autoComplete="email"
              value={data.email}
              placeholder="Correo electrónico"
              onChange={({ target }) =>
                handleOnChange(target)
              }
            />
          </div>
        </div>

        <button
          ref={submitButtonRef}
          type="submit"
          className="ps-login-submit"
        >
          Enviar
        </button>

        <button
          type="button"
          className="ps-login-back"
          onClick={handleChangeToLogIn}
        >
          Volver al inicio de sesión
        </button>

      </form>

      <div className="ps-login-footer">
        PS Proceso Seguro
      </div>

    </div>
  );
}
